<section id="product-category-card-55555" class="style-product-category-card-55555" (mouseenter)="showImages = true" (mouseleave)="showImages = false" (click)="openProductPage(productVariant.url_path)">
    <!-- deal countdown time tag at the top -->
    @if (remainingTime(); as remainingTime) {
    @if (isMobile()) {
    @if (categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isDealCountdownVisible) {
    @if (remainingTime.remainingTime > 1000) {
    <div class="timer-badge timer-badge-text-size timer-badge-text-color timer-badge-font-weight timer-badge-background timer-badge-margin-alignment">
        @if (productDealCountDown.description) {
        {{ productDealCountDown.badge_message + ' ' }}
        }@if (remainingTime.daysToToday) {{{ remainingTime.daysToToday }}{{ remainingTime.daysToToday > 0 ? 'd : ' : '' }}}@if (remainingTime.hoursToToday) {{{ remainingTime.hoursToToday }}{{ remainingTime.hoursToToday > 0 ? 'h : ' : '' }}}{{ remainingTime.minutesToToday }}m : {{ remainingTime.secondsToToday }}s
    </div>
    }
    }
    } @else {
    @if (categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isDealCountdownVisible) {
    @if (remainingTime.remainingTime > 1000) {
    <div class="timer-badge timer-badge-text-size timer-badge-text-color timer-badge-font-weight timer-badge-background timer-badge-margin-alignment">
        @if (productDealCountDown.description) {
        {{ productDealCountDown.badge_message + ' ' }}
        }@if (remainingTime.daysToToday) {{{ remainingTime.daysToToday }}{{ remainingTime.daysToToday > 0 ? 'd : ' : '' }}}@if (remainingTime.hoursToToday) {{{ remainingTime.hoursToToday }}{{ remainingTime.hoursToToday > 0 ? 'h : ' : '' }}}{{ remainingTime.minutesToToday }}m : {{ remainingTime.secondsToToday }}s
    </div>
    }
    }
    }
    }

    <div class="product-card product-card-background product-card-border product-card-border-top-left-radius product-card-border-top-right-radius product-card-border-bottom-right-radius product-card-border-bottom-left-radius editable animated fadeIn">
        <div class="product-card-image-container">
            @if (previewImage) {
            <img [src]="previewImage" />
            } @else {
            <div class="product-card-image-container">
                <img [src]="IMAGE_URLS.noImagePlaceholder" />
            </div>
            }
        </div>

        <div class="product-card-content-container">
            <p class="product-card-product-name product-name-text-size product-name-text-color product-name-font-weight product-name-text-transform">
                {{ product.variant_group?.name || productVariant.display_name || productVariant.name }}
            </p>

            @if (!isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isBrandNameVisible) {
            <div class="product-card-brand-name brand-name-text-size brand-name-text-color brand-name-font-weight brand-name-text-transform">
                {{ productVariant.brand?.name }}
            </div>
            }
            @if (isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isBrandNameVisible) {
            <div class="product-card-brand-name brand-name-text-size brand-name-text-color brand-name-font-weight brand-name-text-transform">
                {{ productVariant.brand?.name }}
            </div>
            }

            <div class="product-card-price-container">
                <p class="product-card-discounted-price discounted-price-text-size discounted-price-text-color discounted-price-font-weight">
                    {{ _sellingPrice | indianCurrency }}
                </p>

                @if (_sellingPrice < _actualPrice) { <p class="product-card-actual-price actual-price-text-size actual-price-text-color actual-price-font-weight">
                    {{ _actualPrice | indianCurrency }}
                    </p>
                    }
                    @if (
                    (!isMobile() &&
                    (categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isPercentageDiscountVisible ??
                    true)) ||
                    (isMobile() &&
                    (categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isPercentageDiscountVisible ?? true))
                    ) {
                    @if (_sellingPrice < _actualPrice) { <p class="percentage-discount-text-size percentage-discount-text-color percentage-discount-font-weight">
                        {{ productVariant | productListingPercentageSave }}
                        </p>
                        }
                        }
            </div>

            <!-- Cash Points section -->
            @if (cashPoints() > 0 && storeConfiguration()?.is_cashpoints_offer_active) {
            <div class="cash-point-container">
                Earn
                <cash-point-svg class="selector-cashpoint" width="100%" height="100%"></cash-point-svg>
                {{ cashPoints() | mathFloor }} Cash Points
            </div>
            }

            @if (!isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.desktop?.isAddToCartVisible) {
            @if (
            !productVariant.variant_values.length &&
            productVariant.in_stock &&
            productVariant.is_active &&
            productVariant.is_visible
            ) {
            <webstore-add-to-cart-action [productInput]="productVariant" [isDisplayAddToCartTextInput]="true"></webstore-add-to-cart-action>
            }
            }
            @if (isMobile() && categoryLayoutData().productCardData.advanceConfiguration?.mobile?.isAddToCartVisible) {
            @if (
            !productVariant.variant_values.length &&
            productVariant.in_stock &&
            productVariant.is_active &&
            productVariant.is_visible
            ) {
            <webstore-add-to-cart-action [productInput]="productVariant" [isDisplayAddToCartTextInput]="true"></webstore-add-to-cart-action>
            }
            }
            @if (colorVariants?.length) {
            <base-variant-viewer [showImages]="showImages" (mouseEnterIndex)="setPreviewImage($event)" (mouseLeaveIndex)="clearPreviewImage()" [variants]="colorVariants">
            </base-variant-viewer>
            }
            @if (categoryLayoutData()?.productCardData?.advanceConfiguration?.isTagVisible) {
            @if (productVariant.tags?.length) {
            <div class="product-card-tag-container">
                <ul>
                    @for (tag of productVariant.tags; track tag) {
                    <li>
                        <div class="product-card-tag product-card-tag-background product-card-tag-border product-card-tag-border-top-left-radius product-card-tag-border-top-right-radius product-card-tag-border-bottom-right-radius product-card-tag-border-bottom-left-radius">
                            <span class="product-card-tag-text-size product-card-tag-text-color product-card-tag-font-weight product-card-tag-text-transform">{{ tag }}</span>
                        </div>
                    </li>
                    }
                </ul>
            </div>
            }
            }
            @if (categoryLayoutData()?.productCardData?.advanceConfiguration?.isDescriptionVisible) {
            <div class="product-card-description product-card-description-text-size product-card-description-text-color product-card-description-font-weight product-card-description-line-height" [innerHTML]="productVariant.one_line_description"></div>
            }
        </div>
    </div>
</section>